import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import InstallDesktopIcon from "@mui/icons-material/InstallDesktop";
import usePwaInstall from "../../hooks/usePwaInstall";
import { getSetting } from "../../services/settingsService";
import { useAuth } from "../../context/AuthContext";

export default function InstallPwaButton() {
  const { isAuthenticated } = useAuth();
  const { canInstall, install } = usePwaInstall();
  const [enabled, setEnabled] = useState(true);

  // Sin sesión no hay token que mandar: /api/settings/... requiere login, y
  // consultarlo igual dispara un 403 que el interceptor de axios traduce en
  // un forceLogout() (window.location.href = "/login"), recargando la página
  // aunque ya estés parado ahí. Por eso solo se consulta con sesión iniciada.
  useEffect(() => {
    if (!isAuthenticated) return;
    let alive = true;
    getSetting("pwa_install_button_enabled")
      .then(({ data }) => {
        if (alive) setEnabled(data?.valor !== "0");
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [isAuthenticated]);

  if (!isAuthenticated || !canInstall || !enabled) return null;

  return (
    <Button
      onClick={install}
      variant="contained"
      color="success"
      startIcon={<InstallDesktopIcon />}
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: (theme) => theme.zIndex.snackbar,
        borderRadius: 999,
        textTransform: "none",
        fontWeight: 700,
        boxShadow: 3,
      }}
    >
      Instalar
    </Button>
  );
}
